import React from 'react';
import { AlertTriangle, X, CheckCircle, Info, AlertCircle } from 'lucide-react';

const ConfirmationModal = ({
    isOpen,
    onClose,
    onConfirm,
    title,
    message,
    type = 'warning',
    confirmText = 'Evet',
    cancelText = 'İptal',
    isLoading = false
}) => {
    if (!isOpen) return null;

    // Modal dışına tıklandığında kapatma
    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget && !isLoading) {
            onClose();
        }
    };

    // Icon ve renk ayarları
    const getIconAndColors = () => {
        switch (type) {
            case 'danger':
                return {
                    icon: AlertCircle,
                    iconColor: 'text-red-500',
                    iconBg: 'bg-red-100 dark:bg-red-900/20',
                    confirmBg: 'bg-red-600 hover:bg-red-700',
                    confirmText: 'text-white'
                };
            case 'warning':
                return {
                    icon: AlertTriangle,
                    iconColor: 'text-yellow-500',
                    iconBg: 'bg-yellow-100 dark:bg-yellow-900/20',
                    confirmBg: 'bg-yellow-600 hover:bg-yellow-700',
                    confirmText: 'text-white'
                };
            case 'info':
                return {
                    icon: Info,
                    iconColor: 'text-blue-500',
                    iconBg: 'bg-blue-100 dark:bg-blue-900/20',
                    confirmBg: 'bg-blue-600 hover:bg-blue-700',
                    confirmText: 'text-white'
                };
            case 'success':
                return {
                    icon: CheckCircle,
                    iconColor: 'text-green-500',
                    iconBg: 'bg-green-100 dark:bg-green-900/20',
                    confirmBg: 'bg-green-600 hover:bg-green-700',
                    confirmText: 'text-white'
                };
            default:
                return {
                    icon: AlertTriangle,
                    iconColor: 'text-gray-500',
                    iconBg: 'bg-gray-100 dark:bg-gray-900/20',
                    confirmBg: 'bg-gray-600 hover:bg-gray-700',
                    confirmText: 'text-white'
                };
        }
    };

    const { icon: Icon, iconColor, iconBg, confirmBg, confirmText: confirmTextColor } = getIconAndColors();

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
            onClick={handleOverlayClick}
        >
            <div
                className="bg-white dark:bg-gray-800 rounded-2xl max-w-md w-full shadow-2xl transform transition-all duration-300 scale-100"
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header */}
                <div className="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700">
                    <div className="flex items-center space-x-3">
                        <div className={`p-2 rounded-full ${iconBg}`}>
                            <Icon className={`h-6 w-6 ${iconColor}`} />
                        </div>
                        <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                            {title}
                        </h3>
                    </div>
                    {!isLoading && (
                        <button
                            onClick={onClose}
                            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
                        >
                            <X className="h-6 w-6" />
                        </button>
                    )}
                </div>

                {/* Content */}
                <div className="p-6">
                    <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
                        {message}
                    </p>
                </div>

                {/* Actions */}
                <div className="flex gap-3 p-6 pt-0">
                    <button
                        onClick={onClose}
                        disabled={isLoading}
                        className="flex-1 px-4 py-3 text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {cancelText}
                    </button>
                    <button
                        onClick={onConfirm}
                        disabled={isLoading}
                        className={`flex-1 px-4 py-3 ${confirmBg} ${confirmTextColor} rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2`}
                    >
                        {isLoading ? (
                            <>
                                <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
                                <span>İşleniyor...</span>
                            </>
                        ) : (
                            <span>{confirmText}</span>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;
